import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { openBackdropLoading } from '../../store/slices/applicationSlice';
import { useDownloadFinanceAuditFileMutation } from '../../store/slices/apiSlice';
import { Grid, Typography } from '@mui/material';
import CustomButton from '../@extended/CustomButton';
import ConfirmationDialog from './ConfirmationDialog';
import { openMessage } from '../../store/slices/showMessageSlice';

const FinanceAuditExport = (props) => {
  const { studySiteMappingId, protocolNumber, style } = props;
  const dispatch = useDispatch();
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    message: (
      <>
        <span>Are you sure you want to download this file?</span>
      </>
    ),
    buttonLabel: 'Download',
  });

  const [downloadAuditFile] = useDownloadFinanceAuditFileMutation();
  const handleDownloadAudit = async () => {
    setConfirmDialog({
      ...confirmDialog,
      open: false,
    });
    const query = {};

    dispatch(openBackdropLoading({ backdropLoading: true }));
    if (studySiteMappingId) {
      query.studySiteMappingId = studySiteMappingId;
    }
    try {
      const _protocolNumber = [];
      if (protocolNumber) {
        _protocolNumber.push(protocolNumber);
      }
      const response = await downloadAuditFile({
        protocolNumber,
        query,
      }).unwrap();

      // Assuming response.data contains the CSV text
      const csvData = response;

      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const now = new Date();
      const date = now.toLocaleDateString().replace(/\//g, '-');
      const time = now.toLocaleTimeString().replace(/:/g, '-');
      const dateTime = `${date}_${time}`;
      const fileTypeExtension = blob.type.split('/')[1];
      a.download = `${
        protocolNumber ? protocolNumber : 'export'
      }_audit_${dateTime}.${fileTypeExtension}`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      dispatch(openBackdropLoading({ backdropLoading: false }));
      dispatch(
        openMessage({
          messageSeverity: 'success',
          message: 'Document downloaded successfully!',
        })
      );
    } catch (error) {
      dispatch(openBackdropLoading({ backdropLoading: false }));
      dispatch(
        openMessage({
          messageSeverity: 'error',
          message: 'Download Failed!',
        })
      );
      console.error('Error downloading audit file:', error);
    }
  };

  const handleConfirmDialogClose = () => {
    setConfirmDialog({
      ...confirmDialog,
      open: false,
    });
  };

  return (
    <Grid display={'flex'} alignItems={'center'}>
      <CustomButton
        variant={'contained'}
        onClick={() =>
          setConfirmDialog({
            ...confirmDialog,
            open: true,
          })
        }
        style={{ ...style }}
      >
          Audit Trail
      </CustomButton>

      <ConfirmationDialog
        open={confirmDialog.open}
        buttonLabel={confirmDialog.buttonLabel}
        message={confirmDialog.message}
        handleClose={handleConfirmDialogClose}
        handleConfirm={handleDownloadAudit}
      />
    </Grid>
  );
};

export default FinanceAuditExport;
